export default "__VITE_ASSET__B_Mcko4C__"